const colors = [
    '#FFCC00', // yellow
    '#0099CC', // blue
    '#00CC99', // green
    '#FF6666', // red
    '#006699', // dark blue
    '#F5A1A1', // pink
    '#666699', // purple
    '#999999',
    '#F69256',
    '#333333',
    '#FF6666',
    '#503D3F',
    '#2B4570',
    '#440381',
    '#440381',
    '#EEEEFF',
    '#7A5C58',
    '#7A5C58',
];

export default colors;
